/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShopifyHealthcheckRequest
 */
export interface ShopifyHealthcheckRequest {
  /**
   *
   * @type {string}
   * @memberof ShopifyHealthcheckRequest
   */
  integrationId: string;
}

/**
 * Check if a given object implements the ShopifyHealthcheckRequest interface.
 */
export function instanceOfShopifyHealthcheckRequest(
  value: object,
): value is ShopifyHealthcheckRequest {
  if (!("integrationId" in value) || value["integrationId"] === undefined)
    return false;
  return true;
}

export function ShopifyHealthcheckRequestFromJSON(
  json: any,
): ShopifyHealthcheckRequest {
  return ShopifyHealthcheckRequestFromJSONTyped(json, false);
}

export function ShopifyHealthcheckRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyHealthcheckRequest {
  if (json == null) {
    return json;
  }
  return {
    integrationId: json["integrationId"],
  };
}

export function ShopifyHealthcheckRequestToJSON(
  json: any,
): ShopifyHealthcheckRequest {
  return ShopifyHealthcheckRequestToJSONTyped(json, false);
}

export function ShopifyHealthcheckRequestToJSONTyped(
  value?: ShopifyHealthcheckRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integrationId: value["integrationId"],
  };
}
